"use client";

import type { CampusEvent } from "@/app/types/events";
import {
  OperationalResult,
  OperationalStatus,
} from "@/app/Components/OperationalPage";
import { buttonClassName } from "@/app/Components/buttonStyles";
import {
  ArrowTopRightOnSquareIcon,
  ClockIcon,
  MapPinIcon,
  TrophyIcon,
} from "@heroicons/react/24/outline";
import { formatSportsEventTime } from "../eventPresentation";
import { sportsSourceLink } from "../sportsSourceLink";

export default function SportsRow({ event }: { event: CampusEvent }) {
  const startTime = formatSportsEventTime(event);
  const source = sportsSourceLink(event);
  return (
    <OperationalResult
      actions={source ? (
        <a
          href={source.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${source.label}: ${event.title}`}
          className={buttonClassName({ variant: "secondary" })}
        >
          {source.label}
          <ArrowTopRightOnSquareIcon aria-hidden="true" className="h-4 w-4" />
        </a>
      ) : undefined}
    >
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <OperationalStatus
              tone="neutral"
              icon={<TrophyIcon className="h-4 w-4" />}
            >
              {event.category ?? "Sports"}
            </OperationalStatus>
            <span className="text-xs text-[var(--ss-text-muted)]">
              {event.host ?? "Rutgers Athletics"}
            </span>
          </div>
          <h3 className="mt-2 break-words text-lg font-semibold text-[var(--ss-text)]">
            {event.title}
          </h3>
          {event.location ? (
            <p className="mt-1 flex items-center gap-1 text-sm text-[var(--ss-text-muted)]">
              <MapPinIcon aria-hidden="true" className="h-4 w-4" />
              {event.location}
            </p>
          ) : null}
        </div>
        <p className="flex items-center gap-1.5 text-xs font-semibold text-[var(--ss-text)]">
          <ClockIcon aria-hidden="true" className="h-4 w-4" />
          {startTime}
        </p>
      </div>
    </OperationalResult>
  );
}
